export const skinCustom = {
  lightComponents: {
    body: '#ECEFF1',
    gradient: {
      gradientDefault1: '#0f7ccf',
      gradientDefault2: '#172260',
    },
  },
  darkComponents: {
    body: '#263238',
    gradient: {
      gradientDefault1: '#172260',
      gradientDefault2: '#000000',
    },
  },
}

export const image = {
  principal: '/images/Logo-Certdigital-branca.png',
  favicon: 'https://certdigitalsms.com.br/image-bank/logocdlbrancoicone.png',
}

export const seo = {
  titulo: 'CertDigital',
  email: 'suporte@senhadigital.com.br',
  palavrasChave:
    'Certificado Digital, Cnpj a1, Cpf a1, emitir certificado, certificado São Mateus do Sul',
  descricao:
    'Empresa líder em Certificação Digital, oferecendo soluções seguras e confiáveis para empresas e indivíduos, com ampla experiência no mercado.',
  descricaoPWA:
    'Certificados digitais são identidades eletrônicas seguras usadas para autenticar usuários, proteger informações e realizar transações online com segurança.',
}

export const header = {
  empresa: false,
  solucoes: false,
  contato: true,
  trabalheConosco: false,
  duvidasSuporte: true,
  parcerias: false,
  darkMode: false,
  contaLogin: true,
}

export const contentHome = {
  sispass: true,
  produtorRural: true,
  modalidadesCertificado: true,
  sdConsulta: false,
}

export const footer = {
  is0800: false,
  telefone: '42 98844-5339',
  whatsapp: '42 98844-5339',
  botaoRenocao: '42988445339',
  comercial: '42988445339',
  botaoWhatsapp: '42988445339',
  number0800: '0800 600 2710',
  cidadeuf: 'São Mateus do Sul/PR',
  cidade: 'São Mateus do Sul',
  bairro: 'Centro',
  titulo: 'Certificado Digital em São Mateus do Sul',
  rua: 'Rua Agenor Nascimento',
  numero: '591',
  complemento: '',
  cep: '83900-000',
  cnpj: '',
  messageContador: 'Olá, tenho interesse em ser Parceiro Indicador.',
  messageRevenda: 'Olá, tenho interesse em revender Certificados Digitais',
  messageAgendamento: 'Olá, gostaria de agendar a emissão do meu Certificado',
  messageRenovacao: 'Olá, gostaria de renovar meu Certificado Digital',
  messageRenovacaoSispass:
    'Olá, gostaria de renovar meu Certificado Digital Sispass',
  messageConhecaNossasSolucoes:
    'Olá, gostaria de conhecer as soluções da CertDigital',
}

export const redes = {
  facebook: 'https://www.facebook.com/cdlsaomateusdosul/?locale=pt_BR',
  instagram: 'https://www.instagram.com/cdlsms/',
  linkedin: '',
}

export const digisac = {
  id: 'df7a6a14-269a-46ba-a874-33c45e74badf',
  status: false,
}

export const ratings = [
  {
    id: 1,
    descricao: 'Suporte e Atendimento excelentes!',
    author: 'Leonardo Lopes',
    ratingvalue: 5,
  },
  {
    id: 2,
    descricao:
      'Atendimento excelente. Super ágil, prático e simplificado! Ótima organização da equipe.',
    author: 'Tháliton Morais',
    ratingvalue: 5,
  },
  {
    id: 3,
    descricao: 'Atendimento do Suporte Técnico nota 10!.',
    author: 'Felipe Mourão',
    ratingvalue: 5,
  },
]
